import React, { Fragment, useEffect } from "react";
import Layout from "../core/Layout";
import { useListMedicines, useDeleteMedicine } from "../component/api/medicine";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Menu, Dropdown, Button } from "antd";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";

const ListMedicine = () => {
	const navigate = useNavigate();
	const { data: medicines = [], isLoading: loading, error } = useListMedicines();
	const deleteMedicineMutation = useDeleteMedicine();

	const userLogin = useSelector((state) => state.userLogin);
	const { userInfo } = userLogin;

	useEffect(() => {
		if (!userInfo) {
			navigate("/signin");
		}
	}, [userInfo, navigate]);

	const deleteHandler = (id) => {
		if (window.confirm("Are you sure")) {
			deleteMedicineMutation.mutate(id);
		}
	};

	const showError = () => (
		<div
			className="alert alert-danger"
			style={{ display: error ? "" : "none" }}>
			{error}
		</div>
	);

	const showLoading = () =>
		loading && (
			<div className="d-flex justify-content-center">
				<div className="spinner-border" role="status">
					<span className="sr-only">Loading...</span>
				</div>
			</div>
		);

	const cardStyles = {
		background: "white",
		borderRadius: "15px",
		boxShadow: "0 10px 30px rgba(102, 126, 234, 0.1)",
		border: "1px solid rgba(102, 126, 234, 0.1)",
		overflow: "hidden",
		marginBottom: "20px"
	};

	const headerStyles = {
		background: "linear-gradient(135deg, rgb(102, 126, 234) 0%, rgb(118, 75, 162) 100%)",
		color: "white",
		borderRadius: "15px 15px 0px 0px",
		padding: "20px 25px",
		borderBottom: "none",
		marginBottom: "0"
	};

	const tableHeaderStyles = {
		background: "linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%)",
		color: "#666a7e",
		fontWeight: "600",
		// padding: "15px",
		borderBottom: "2px solid rgba(102, 126, 234, 0.2)"
	};

	const tableCellStyles = {
		// padding: "12px 15px",
		borderBottom: "1px solid rgba(102, 126, 234, 0.1)",
		color: "#000000"
	};

	const inputStyles = {
		borderRadius: "10px",
		border: "2px solid rgba(102, 126, 234, 0.2)",
		padding: "10px 14px",
		fontSize: "14px",
		transition: "all 0.3s ease",
		outline: "none",
		boxShadow: "0 2px 8px rgba(102, 126, 234, 0.1)",
		width: "100%",
		minHeight: "42px"
	};

	// const tableStyles = {
	// 	width: "100%",
	// 	boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
	// 	borderCollapse: "separate",
	// 	borderSpacing: "0 10px",
	// 	margin: "20px 0",
	// 	borderRadius: "8px",
	// 	fontFamily: "Roboto sans-serif",
	// };

	const theadStyles = {
		backgroundColor: "#f8f9fa",
		fontWeight: "bold",
		textAlign: "center",
		fontFamily: "Roboto sans-serif",
	};

	const rowStyles = {
		backgroundColor: "#fff",
		borderBottom: "1px solid #dee2e6",
		transition: "background-color 0.3s",
		textAlign: "center",
		fontFamily: "Roboto sans-serif",
	};

	const emailStyles = {
		fontStyle: "italic",
		color: "#495057",
		fontFamily: "Roboto sans-serif",
	};

	// const buttonStyles = {
	// 	borderRadius: "20px",
	// 	padding: "3px 10px",
	// 	fontSize: "12px",
	// 	fontWeight: "bold",
	// 	fontFamily: "Roboto sans-serif",
		
	// };

	const buttonStyles = {
		background: "linear-gradient(135deg, rgb(102, 126, 234) 0%, rgb(118, 75, 162) 100%)",
		color: "white",
		borderRadius: "20px",
		padding: "8px 16px",
		fontSize: "12px",
		fontWeight: "bold",
		fontFamily: "Roboto sans-serif",
		border: "none",
		boxShadow: "0 4px 12px rgba(102, 126, 234, 0.3)",
		transition: "all 0.3s ease",
	};

	const iconStyles = {
		fontSize: "18px",
		color: "#495057",
		cursor: "pointer",
		transition: "color 0.3s",
		fontFamily: "Roboto sans-serif",
	};
	const centeredHeading = {
		display: "flex",
		justifyContent: "center", // Centers horizontally
		alignItems: "center", // Centers vertically (if there's height)
		textAlign: "center",
		height: "100px", // Optional: Adjust height as needed for vertical centering
		margin: "0 auto",
		fontWeight: "bold",
		fontFamily: "Roboto sans-serif",
	};

	return (
		<Layout
			title=""
			description=""
			className="container-fluid">
			{/* <h4>
				<Link to="/add-medicine">
					<button
						className="btn btn-primary btn-sm"
						style={buttonStyles}>
						Add Medicine
					</button>
				</Link>
			</h4> */}
			<div style={cardStyles}>
				<div style={headerStyles}>
					<div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
						<h2 style={{ margin: "0", fontSize: "24px", fontWeight: "600" }}>List Medicine</h2>
						<Link to="/add-medicine">
							<Button type="primary" style={buttonStyles}>
								+ Add Medicine
							</Button>
						</Link>
					</div>
				</div>
				<div style={{ padding: "25px" }}>
					{loading ? (
						showLoading()
					) : error ? (
						showError()
					) : medicines.length === 0 ? (
						<div className="row">
							<div className="table-responsive my-4">
								<table className="table">
									<thead>
										<tr className="text-center">
											<th style={tableHeaderStyles}>Id</th>
											<th style={tableHeaderStyles}>name</th>
											<th style={tableHeaderStyles}>Generic Name</th>
											<th style={tableHeaderStyles}>Batch No</th>
											<th style={tableHeaderStyles}>Bar Code</th>
											<th style={tableHeaderStyles}>Quantity</th>
											<th style={tableHeaderStyles}>Type</th>
											<th style={tableHeaderStyles}>Man Date</th>
											<th style={tableHeaderStyles}>Expiry Date</th>
											<th style={tableHeaderStyles}>Cost</th>
											<th style={tableHeaderStyles}>Vendors</th>
											<th style={tableHeaderStyles}>Edit</th>
											<th style={tableHeaderStyles}>Delete</th>
										</tr>
									</thead>
									<tbody>
										<tr className="text-centr">
											<td className="text-center">No Data</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					) : (
						<div className="row">
							<div className="table-responsive my-4">
								{/* <table className="table"> */}
								<table className="table" style={{ borderRadius: "10px", overflow: "hidden", boxShadow: "0 4px 12px rgba(102, 126, 234, 0.1)" }}>
									<thead>
										<tr className="text-center">
											<th style={tableHeaderStyles}>Id</th>
											<th style={tableHeaderStyles}>name</th>
											<th style={tableHeaderStyles}>Generic Name</th>
											<th style={tableHeaderStyles}>Batch No</th>
											<th style={tableHeaderStyles}>Bar Code</th>
											<th style={tableHeaderStyles}>Quantity</th>
											<th style={tableHeaderStyles}>Type</th>
											<th style={tableHeaderStyles}>Man Date</th>
											<th style={tableHeaderStyles}>Expiry Date</th>
											<th style={tableHeaderStyles}>Cost</th>
											<th style={tableHeaderStyles}>Vendors</th>
											<th style={tableHeaderStyles}>Edit</th>
											<th style={tableHeaderStyles}>Delete</th>
										</tr>
									</thead>
									<tbody>
										{medicines &&
											medicines.map((med, i) => (
												<tr key={i} className="text-center" style={{ transition: "all 0.3s ease" }}
										onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "rgba(102, 126, 234, 0.25)"}
										onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "transparent"}>
													<Fragment>
														<th style={tableCellStyles} scope="row">
															{med._id.substring(0, 7)}
														</th>
														<td style={tableCellStyles}>{med?.name}</td>
														<td style={tableCellStyles}>{med?.genericName}</td>
														<td style={tableCellStyles}>{med?.batchNo}</td>
														<td style={tableCellStyles}>{med?.barCode}</td>
														<td style={tableCellStyles}>{med?.quantity}</td>
														<td style={tableCellStyles}>{med?.type}</td>
														<td style={tableCellStyles}>
															{dayjs(
																med?.manDate
															).format("YYYY-MM-DD")}
														</td>
														<td style={tableCellStyles}>
															{dayjs(
																med?.expDate
															).format("YYYY-MM-DD")}
														</td>
														<td style={tableCellStyles}>{med?.cost}</td>
														<td style={tableCellStyles}>{med?.vendor?.name}</td>
														<td style={tableCellStyles}>
															<Link
																to={`/update-medicine/${med._id}`}>
																<i className="bi bi-pencil-square" />
															</Link>
														</td>
														<td style={tableCellStyles}>
															<i
																className="bi bi-trash"
																onClick={() =>
																	deleteHandler(
																		med._id
																	)
																}
															/>
														</td>
													</Fragment>
												</tr>
											))}
									</tbody>
								</table>
							</div>
						</div>
					)}
				</div>
			</div>
		</Layout>
	);
};

export default ListMedicine;
